import { PatientIdentityModal } from "../../../administration/components/PatientIdentityModal";
import { ChronicBillConfirmModal, ChronicDeleteConfirmModal, ChronicHistoryModal, ChronicProductModal } from "./ChronicBillingModals";
import { DeleteDossierModal, DossierContextMenu, PrintReportConfirmModal } from "./DossierDialogs";

// Fenêtres communes aux deux écrans de contrôle : facturation chronique, gestion des dossiers, rapport et fiche patient.
// overlayStyle et identityZIndex permettent d'empiler ces fenêtres au-dessus d'une fenêtre déjà ouverte.
export function ControleDialogs({ workspace, controle, editing, chronic, report, remainingPatientCount, overlayStyle, idPrefix, identityZIndex }) {
    return (
        <>
            <DossierContextMenu menu={workspace.contextMenu} onClose={workspace.closeContextMenu} onDelete={workspace.requestDelete} />
            <DeleteDossierModal candidate={workspace.deleteCandidate} saving={workspace.saving} onCancel={workspace.cancelDelete} onConfirm={workspace.confirmDelete} />
            <PrintReportConfirmModal
                open={report.confirmOpen}
                remainingPatientCount={remainingPatientCount}
                onCancel={report.cancel}
                onConfirm={report.confirm}
            />
            <ChronicProductModal chronic={chronic} patient={controle.selectedPatient} overlayStyle={overlayStyle} idPrefix={idPrefix} />
            <ChronicDeleteConfirmModal chronic={chronic} overlayStyle={overlayStyle} />
            <ChronicBillConfirmModal chronic={chronic} overlayStyle={overlayStyle} />
            <ChronicHistoryModal chronic={chronic} overlayStyle={overlayStyle} idPrefix={idPrefix} />
            {editing.identityRow && (
                <PatientIdentityModal
                    row={editing.identityRow}
                    productionSubcategories={workspace.selectedEhpad?.productionSubcategories ?? []}
                    onClose={() => editing.setIdentityRow(null)}
                    onSave={identity => editing.saveIdentity(editing.identityRow, identity)}
                    onDelete={() => editing.deletePatient(editing.identityRow.patientId)}
                    modalZIndex={identityZIndex}
                />
            )}
        </>
    );
}

// Le bouton de modification d'un patient n'apparaît qu'au survol ou au focus de sa ligne.
export function PatientRowHoverStyle() {
    return (
        <style>
            {`
                    .controle-patient-row .controle-patient-edit-button {
                        opacity: 0;
                    }
                    .controle-patient-row:hover .controle-patient-edit-button,
                    .controle-patient-row:focus-within .controle-patient-edit-button {
                        opacity: 1;
                    }
                `}
        </style>
    );
}
